import React, { useState, useContext } from "react";

import ReactDOM from "react-dom";
import CloseCommand from "../Commands/CloseCommand/CloseCommand";
import useValidationInput from "../../Hooks/useValidationInput.js";
import RadioIcon from "../Commands/RadioIcon/RadioIcon";
import ValidationCommand from "../Commands/ValidationCommand/ValidationCommand";
import useChangeMode from "../../Hooks/useChangeMode.js";
import { store } from "../../store.js";

export default function SimpleDialog (props)  {
  const isInputValid = useValidationInput();
  const globalState = useContext(store);
  const changeMode = useChangeMode();
  const currentFormat = globalState.state.formData;
  const [position, setPosition] = useState({ 
    operation : props.operation,
    type: props.type,
    isOpen:true,
    value:props.value
  });

  const getTitle = (replaces) => {
    const currentType =  position.errorType ? position.errorType : position.operation
    return currentFormat.log.filter(
      log => log.type == currentType
    ).map( log =>  {return <span style = {log.style}>{replaceValue(log.value, replaces)}</span>})[0]
  }
  
  const onClickClose = (e) => {
    if(e) e.preventDefault(); 
    props.onClose();
    var updatedPosition = JSON.parse(JSON.stringify(position));
    updatedPosition.isOpen = false;
    setPosition(updatedPosition);
  }

  const replaceValue = (value, replaces) => {
    if( replaces )
      replaces.map(replace => value = value.replace(replace.old, replace.new)) 
    return value
  }

  const onClickValid = (e) => {
    onClickClose(e)
    
    if (position.value !="" && position.value != undefined)
    props.onClickValid(e, position)
    //Validation(option)
  }
  
  
  const fireEventByMenuAndSetValue = (e, menuType, event) => {
    
    var updatedPosition = JSON.parse(JSON.stringify(position));
    updatedPosition.value = e.target.value;
    const typeEvents = currentFormat.menu[menuType].validations ? currentFormat.menu[menuType].validations[event] : []
    const eventResponse = isInputValid({value: e.target.value}, typeEvents);
    if(eventResponse.isValid)
      updatedPosition["errorType"] = undefined;
    else
      updatedPosition["errorType"] = eventResponse.type;
    
    setPosition(updatedPosition);
  }

  return (
    position.isOpen && ReactDOM.createPortal(
    <div className="dialogForm" style ={{   height: "70px", width: "210px" }}>
      <div style ={{  display: "flex" }} onClick={(e) => {e.stopPropagation() }}>
        <div style ={{ fontSize: "14px", marginTop: "6px", marginRight: "10px" }}>
          { getTitle(currentFormat.menu[position.type].replacesValues) }
        </div>
        
        <div onClick={(e) => onClickClose(e) } style ={{ marginLeft: "auto", marginRight: "4px" }}>
          <CloseCommand />
        </div>
      </div>
      <div style ={{  display: "flex" }} onClick={(e) => {e.stopPropagation() }}>
        <div style ={{ width: "180px", marginTop: "4px", marginRight: "5px"}}>
          { props.isLabel ? <span>{position.value}</span> :
          <input className="textBox" style ={{ width: "175px" }}
            onMouseLeave={() => props.changeModeRequired && changeMode(false)}
            onMouseDown={() => props.changeModeRequired &&  changeMode(true)}
            onChange = {(e) => fireEventByMenuAndSetValue(e, currentFormat.menu.type[position.type],currentFormat.actions.event.type.onChange) }
            onMouseLeave = {(e) => fireEventByMenuAndSetValue(e, currentFormat.menu.type[position.type],currentFormat.actions.event.type.onMouseLeave) }
            value = {position.value}></input>
          }
        </div>
        <div style ={{marginLeft: "auto", marginRight: "4px" }}>
          <ValidationCommand onClick ={(e) => onClickValid(e) } className ="hoverGreen"/>
        </div>
      </div>

      
    </div>,
     document.getElementById(props.parentId)
    ) 
  );
}

